export default {
  setUser(state, payload) {
    state.rules = payload.rules;
    state.token = payload.token;
    state.userId = payload.userId;
    state.userName = payload.userName;
    state.department = payload.department;
    state.userInfo = {
      userId: payload.userId,
      userName: payload.userName,
      department: payload.department,
    };
    state.versionData = payload.versionData;
  },
  setAutoLogout(state) {
    state.didAutoLogout = true;
  },
  setFlagNeedsRefresh(state) {
    state.needsRefresh = true;
  },
};

//payload = {subject: "manage", action: "create"}
